import React, { useEffect, useState } from 'react'
import Common from '../component/Common'
import IMG from '../images/illus.png'
import check from '../images/check-circle.gif'
import work from '../images/undraw_multitasking_hqg3.svg'
import work1 from '../images/undraw_Progress_indicator_re_4o4n.svg'
import gif from '../images/955-demand-outline.gif'
import contactIllus from '../images/contact_illustration.jpg'
import db from '../auth/fireDb'
import { store } from 'react-notifications-component'
const MarketPlace = () => {
    const [firstName, setFirstName] = useState("")
    const [lastName, setLastName] = useState("")
    const [email, setEmail] = useState("")
    const [mobile, setMobile] = useState("")
    const [city, setCity] = useState("")
    const [zip, setZip] = useState("")
    const [previousJob, setPreviousJob] = useState("")
    const [profession, setProfession] = useState("")
    const [reference, setReference] = useState("")
    const [emailErrorMessage, setEmailErrorMessage] = useState("");
    const [emailError, setEmailError] = useState(false)

    function notifyPopup(message, type) {
        store.addNotification({
            title: message,
            message: message,
            type: type,
            background: "pink",
            insert: "top",
            container: "top-right",
            animationIn: ["animate__animated", "animate__fadeIn"],
            animationOut: ["animate__animated", "animate__fadeOut"],
            dismiss: {
                duration: 3000,
                onScreen: true,
            },
        });
    };
    function validateEmail(email) {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (re.test(String(email).toLowerCase())) {
            return true;
        }
        else return false;
    }
    function handleEmail(event) {
        if (validateEmail(event.target.value)) {
            setEmail(event.target.value);
            setEmailError(false)
            setEmailErrorMessage("")
        } else {
            setEmailError(true)
            setEmailErrorMessage("Incorrect Email Format!")
        }
    }
    function handleFirstName(event) {
        setFirstName(event.target.value);
    }
    function handleLastName(event) {
        setLastName(event.target.value);
    }
    function handleCity(event) {
        setCity(event.target.value);
    }
    function handleProfession(event) {
        setProfession(event.target.value);
    }
    function handlePreviousJob(event) {
        setPreviousJob(event.target.value);
    }
    function handleReference(event) {
        setReference(event.target.value);
    }
    function handleZip(event) {
        setZip(event.target.value);
    }
    function handleMobile(event) {
        setMobile(event.target.value);
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        if (reference === mobile) {
            notifyPopup("Reference Can't Be Your Personal Number","warning")
            return
        } else {
            db.collection("mentor-request").add({
                email,
                firstName, lastName,
                profession, previousJob, city, zip,
                mobile,reference
            })
                .then((docRef) => {
                    notifyPopup("We Will Contact You Soon!", "success")
                    setEmail("")
                    setFirstName("")
                    setLastName("")
                    setMobile("")
                    setCity("")
                    setZip("")
                    setPreviousJob("")
                    setProfession("")
                })
                .catch((error) => {
                    console.error("Error adding document: ", error);
                });
        }

    }

    useEffect(() => {
        document.title = "CareerGrads | Market Place"
    }, [])
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])
    return (
        <div>
            <Common
                name={'We Provide Tutors According to your Needs'}
                btname={0}
                content={"Best Tutor's for your Learning to head start your growth"}
                visit={0}
                imgsrc={IMG}
            />

            <div className="container-fluid my-5">
                <div className="container">

                    <div className="row">
                        <div className="col-lg 6 col-md-6 col-sm-12 mx-auto text-center">
                            <img src={work} className="img-responsive img-fluid" style={{ width: "80%", height: "80%" }} />
                        </div>
                        <div className="col-lg 6 col-md-6 col-sm-12 mx-auto d-flex flex-column justify-content-center">
                            <h2 className="my-4 font-weight-bold"> Why work with us?
                        </h2><div className="my-4 d-flex flex-row ">
                                <img src={check} style={{ width: "40px", height: "40px", margin: "5px" }} />
                                <p>CareerGrads has a mission to upskill the students in a way that their skills and efforts don't go to waste</p>
                            </div>
                            <div className="my-4 d-flex flex-row">
                                <img src={check} style={{ width: "40px", height: "40px", margin: "5px" }} />
                                <p>We want our students to get the best practical knowledge that they can implement themselves-
                                in their projects and corporate work. If you think, this aligns with your motive as a tutor,
                                    feel free to reach out to us at info@careergrads.com with your resume.</p>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div className="container-fluid my-5 ">
                <div className="container">

                    <div className="row">

                        <div className="col-lg 6 col-md-6 col-sm-12 mx-auto d-flex flex-column justify-content-center">
                            <h2 className="my-4  font-weight-bold">What are the perks and incentives to choose us as a partner ?
                        </h2>
                            <div className="my-4 d-flex flex-row ">
                                <img src={gif} style={{ width: "60px", height: "60px", margin: "5px" }} />
                                <p>Our students have always been motivated to perform extremely well.
                                CareerGrads has consistently worked to empower not only the students,
                                but their families with correct information, real-world scenarios and
                                honest opinions.
                               </p>
                            </div>
                            <div className="my-4 d-flex flex-row">
                                <img src={gif} style={{ width: "60px", height: "60px", margin: "5px" }} />
                                <p>Our customer base is a set of committed people
                                who love being connected to us. Our organisation has also partnered with
                                several universities and colleges that are constantly in touch with us for
                                industry updates and the best resources for students.</p>
                            </div>
                            <div className="my-4 d-flex flex-row">
                                <img src={gif} style={{ width: "60px", height: "60px", margin: "5px" }} />
                                <p> The team at CareerGrads are extremely passionate individuals who are
                                always ready to collaborate and work through problems, leading to excellent
                                     workflow.</p>
                            </div>
                        </div>
                        <div className="col-lg 6 col-md-6 col-sm-12 mx-auto text-center my-auto order-first">
                            <img src={work1} className="img-responsive img-fluid " />
                        </div>
                    </div>
                </div>
            </div>
            <div className="container">
                <div className="row">
                    <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mx-auto">
                        <img src={contactIllus} alt="become-mentor" className="img-fluid img-responsive" />
                    </div>
                    <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mx-auto">
                        <div className="container-fluid my-5 card shadow">
                            <h3 className="my-4 ">
                                Become A Mentor
                                        </h3>
                            <form id="contact-form" className="form my-4" role="form" onSubmit={handleSubmit}>
                                <div class="form-group">
                                    <label className="form-label  font-weight-bold" for="fname">Your First Name</label>
                                    <input type="text" required className="form-control  " id="fname" name="fname" placeholder="First Name" tabindex="1" required onChange={handleFirstName} />
                                </div>
                                <div class="form-group">
                                    <label className="form-label  font-weight-bold" for="lname">Your Last Name</label>
                                    <input type="text" required className="form-control  " id="lname" name="lname" placeholder="Last Name" tabindex="1" required onChange={handleLastName} />
                                </div>
                                <div className="form-group">
                                    <label className="form-label font-weight-bold" for="email">Your Email</label>
                                    <input type="email" required className="form-control" id="email" name="email" placeholder="Your Email" tabindex="2" required onChange={handleEmail} />
                                    <p className="text-danger">{emailError ? emailErrorMessage : null}</p>
                                </div>
                                <div className="form-group">
                                    <label className="form-label font-weight-bold" for="mobile">Mobile</label>
                                    <input type="text" required className="form-control" id="mobile" name="mobile" placeholder="Mobile" tabindex="3" typeof="number" required onChange={handleMobile} />
                                </div>
                                <div className="form-group">
                                    <label className="form-label font-weight-bold" for="profession">Profession</label>
                                    <input row="2" type="text" required name="profession" className="form-control" id="profession" placeholder="Profession" tabindex="4" required onChange={handleProfession} />
                                </div>
                                <div className="form-group">
                                    <label className="form-label font-weight-bold" for="reference">Reference</label>
                                    <input row="2" type="text" required name="reference" className="form-control" id="reference" placeholder="Put Mobile Number of Reference" tabindex="4" required onChange={handleReference} />
                                </div>
                                <div className="form-group">
                                    <label className="form-label font-weight-bold" for="previous_job">Previous Job</label>
                                    <input type="text" required name="previous_job" className="form-control" id="previous_job" placeholder="Previous Job" tabindex="4" required onChange={handlePreviousJob} />
                                </div>
                                <div className="d-flex flex-row justify-content-around">
                                    <div className="form-group">
                                        <label className="form-label font-weight-bold" for="city">City</label>
                                        <input type="text" required name="city" className="form-control" id="city" placeholder="City" tabindex="4" required onChange={handleCity} />
                                    </div> <div className="form-group">
                                        <label className="form-label font-weight-bold" for="postal_code">Postal Code</label>
                                        <input type="text" required name="postal_code" className="form-control" id="postal_code" placeholder="Postal Code" tabindex="4" required onChange={handleZip} />
                                    </div>
                                </div>
                                <div className="text-center ">
                                    <button className="btn btn-block bg-primary font-weight-bold text-white mt-4 btn-start-order btn-explore" type="submit">Submit!</button>
                                </div>
                            </form>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}
export default MarketPlace;
